import axios from "axios";
import React, { useEffect, useState } from "react";

const EventCart = () => {
  const [activeTab, setActiveTab] = useState("tabCart"); // Default active tab
  const [cartItems, setCartItems] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedHour, setSelectedHour] = useState("");
  const [selectedMinute, setSelectedMinute] = useState("");
  const [selectedPeriod, setSelectedPeriod] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [VenueName, setVenueName] = useState("");
  const [VenueStreetAddressOne, setVenueStreetAddressOne] = useState("");
  const [VenueStreetAddressTwo, setVenueStreetAddressTwo] = useState("");
  const [VenueCity, setVenueCity] = useState("");
  const [VenueState, setVenueState] = useState("");
  const [VenuePostalCode, setVenuePostalCode] = useState("");
  const [VenueNotes, setVenueNotes] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedPricingValue, setSelectedPricingValue] = useState("");
  const [projectSelectDate, setProjectSelectedDate] = useState("");
  const [projectSelectedHour, setProjectSelectedHour] = useState("12");
  const [projectSelectedMinute, setProjectSelectedMinute] = useState("00");
  const [projectSelectedPeriod, setProjectSelectedPeriod] = useState("AM");

  const [projectSelectEndDate, setProjectSelectedEndDate] = useState("");
  const [projectSelectedEndHour, setProjectSelectedEndHour] = useState("12");
  const [projectSelectedEndMinute, setProjectSelectedEndMinute] =
    useState("00");
  const [projectSelectedEndPeriod, setProjectSelectedEndPeriod] =
    useState("AM");
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://server-gs.vercel.app/event-company-tax-value"
        );
        setData(response.data);
        setError(null); // Clear any previous errors
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        // setLoading(false);
      }
    };

    // Fetch data every second
    const intervalId = setInterval(fetchData, 1000);

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when component mounts
  }, []);

  useEffect(() => {
    // Function to retrieve and update cart data
    const updateCartData = () => {
      const storedCartData = localStorage.getItem("cart");
      if (storedCartData) {
        const parsedCart = JSON.parse(storedCartData);
        setCartItems(parsedCart);

        // Extract and set preselected date & time
        if (parsedCart[0]?.selectedDate) {
          const date = new Date(parsedCart[0].selectedDate);
          const hours = date.getHours();
          const minutes = date.getMinutes();
          setSelectedDate(date.toISOString().split("T")[0]); // Format: YYYY-MM-DD
          setSelectedHour(hours % 12 || 12); // Convert to 12-hour format
          setSelectedMinute(minutes < 10 ? `0${minutes}` : minutes);
          setSelectedPeriod(hours >= 12 ? "PM" : "AM");
        }
      }
    };

    // Call immediately on mount
    updateCartData();

    // Set an interval to update cart data periodically
    const intervalId = setInterval(updateCartData, 1000); // Update every 5 seconds

    // Cleanup interval on unmount
    return () => clearInterval(intervalId);
  }, []);

  // Automatically update localStorage whenever cartItems changes
  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cartItems));
  }, [cartItems]);

  const handleQuantityChange = (index, increment) => {
    setCartItems((prevItems) => {
      const updatedItems = [...prevItems];
      updatedItems[index].quantity = Math.max(
        1,
        updatedItems[index].quantity + increment
      ); // Ensure quantity doesn't go below 1
      return updatedItems;
    });
  };

  const removeFromCart = (productToRemove) => {
    setCartItems((prevItems) =>
      prevItems.filter((product) => product._id !== productToRemove._id)
    );
  };

  const handlePricingChange = (index, pricingType, pricingOption) => {
    setCartItems((prevItems) => {
      const updatedItems = [...prevItems];
      updatedItems[index].selectedPricingType = pricingType;
      updatedItems[index].selectedPricingOption = pricingOption;

      const pricingOptions =
        pricingType === "dailyPricing"
          ? updatedItems[index].dailyPricing
          : pricingType === "hourlyPricing"
          ? updatedItems[index].hourlyPricing
          : [];
      const selectedPrice = pricingOptions?.find(
        (price) => price[pricingOption] !== undefined
      );
      const priceValue = selectedPrice ? Object.values(selectedPrice)[0] : 0;
      updatedItems[index].selectedPricingValue = priceValue;

      // Update the standalone selectedPricingValue
      setSelectedPricingValue(priceValue);

      return updatedItems;
    });
  };

  const handleDateTimeChange = (index, date, hour, minute, period) => {
    const formattedDate = new Date(
      `${date} ${hour}:${minute} ${period}`
    ).toISOString();

    setCartItems((prevItems) => {
      const updatedItems = [...prevItems];
      updatedItems[index] = {
        ...updatedItems[index],
        selectedDate: formattedDate, // Update full date-time string
        selectedHour: hour, // Update specific hour
        selectedMinute: minute, // Update specific minute
        selectedPeriod: period, // Update AM/PM
      };
      return updatedItems;
    });
  };

  const totalCartPrice = cartItems.reduce((total, item) => {
    const selectedPricingType = item.selectedPricingType || "dailyPricing";
    const selectedPricingOption = item.selectedPricingOption || "OneDay";
    const pricingOptions =
      selectedPricingType === "dailyPricing"
        ? item.dailyPricing
        : selectedPricingType === "hourlyPricing"
        ? item.hourlyPricing
        : [];
    const selectedPrice = pricingOptions?.find(
      (price) => price[selectedPricingOption] !== undefined
    );
    const priceValue = selectedPrice
      ? parseFloat(Object.values(selectedPrice)[0])
      : 0;
    return total + priceValue * item.quantity;
  }, 0);

  const resetForm = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setVenueName("");
    setVenueStreetAddressOne("");
    setVenueStreetAddressTwo("");
    setVenueCity("");
    setVenueState("");
    setVenuePostalCode("");
    setVenueNotes("");
    setPhoneNumber("");
    setSelectedPricingValue("");
    setProjectSelectedDate("");
    setProjectSelectedHour("12");
    setProjectSelectedMinute("00");
    setProjectSelectedPeriod("AM");
    setProjectSelectedEndDate("");
    setProjectSelectedEndHour("12");
    setProjectSelectedEndMinute("00");
    setProjectSelectedEndPeriod("AM");
    setCartItems([]); // Clear the cart items
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Function to generate a unique set code
    const generateSetCode = () => {
      return Math.random().toString(36).substr(2, 8).toUpperCase();
    };

    const setCode = generateSetCode(); // Generate the code dynamically

    // Parse and format the start date
    const [startYear, startMonth, startDay] = projectSelectDate.split("-");
    let startHour = parseInt(projectSelectedHour, 10);
    const startMinute = parseInt(projectSelectedMinute, 10);

    if (projectSelectedPeriod === "PM" && startHour < 12) startHour += 12;
    if (projectSelectedPeriod === "AM" && startHour === 12) startHour = 0;

    const combinedStartDate = new Date(
      Date.UTC(startYear, startMonth - 1, startDay, startHour, startMinute)
    );

    // Parse and format the end date
    const [endYear, endMonth, endDay] = projectSelectEndDate.split("-");
    let endHour = parseInt(projectSelectedEndHour, 10);
    const endMinute = parseInt(projectSelectedEndMinute, 10);

    if (projectSelectedEndPeriod === "PM" && endHour < 12) endHour += 12;
    if (projectSelectedEndPeriod === "AM" && endHour === 12) endHour = 0;

    const combinedEndDate = new Date(
      Date.UTC(endYear, endMonth - 1, endDay, endHour, endMinute)
    );

    const paymentData = {
      firstName,
      lastName,
      phoneNumber,
      email,
      VenueStreetAddressOne,
      VenueStreetAddressTwo,
      VenueCity,
      VenueState,
      VenuePostalCode,
      VenueNotes,
      projectSelectDate: combinedStartDate,
      projectSelectEndDate: combinedEndDate,
      set: [
        {
          setCode, // Use the dynamically generated setCode
          setTitle: VenueName,
          startDate: combinedStartDate,
          endDate: combinedEndDate,
          products: cartItems.map((item) => {
            const priceValue = item.perDayPricing;
            const productTotal = item.perDayPricing * item.quantity;

            return {
              singleImage: item.singleImage,
              title: item.title,
              productId: item.productId,
              quantity: item.quantity,
              selectedDate: item.selectedDate,
              contractDescription: item.contractDescription,
              productDescription: item.productDescription,
              internalNotes: item.internalNotes,
              length: item.length,
              height: item.height,
              shape: item.shape,
              width: item.width,
              productCode: item.productCode,
              selectedPricingValue: priceValue,
              tax: data?.taxValue,
              productTotal,
            };
          }),
        },
      ],
      totalPrice: totalCartPrice,
    };

    // Send the payment data to the server
    const response = await fetch("https://server-gs.vercel.app/save-payment", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(paymentData),
    });

    if (response.ok) {
      alert("Quote request sent successfully!");
      resetForm();
    } else {
      alert("Failed to save payment details.");
    }
  };

  const [dropdownVisible, setDropdownVisible] = useState({});

  // Function to toggle dropdown visibility
  const toggleDropdown = (index) => {
    setDropdownVisible((prev) => ({
      ...prev,
      [index]: !prev[index], // Toggle the visibility for the specific item
    }));
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5; // Number of items per page

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = cartItems.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(cartItems.length / itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handlePhoneChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove all non-digit characters
    if (value.length > 3 && value.length <= 6) {
      value = `(${value.slice(0, 3)}) ${value.slice(3)}`;
    } else if (value.length > 6) {
      value = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(
        6,
        10
      )}`;
    } else if (value.length > 3) {
      value = `(${value.slice(0, 3)}) ${value.slice(3)}`;
    }
    setPhoneNumber(value);
  };

    useEffect(() => {
      // If the start date is selected, make sure the end date cannot be before it
      setProjectSelectedEndDate(prevEndDate => {
        if (prevEndDate && prevEndDate < projectSelectDate) {
          return projectSelectDate; // reset end date to the start date if it's earlier
        }
        return prevEndDate;
      });
    }, [projectSelectDate]); // Re-run whenever the start date changes

  return (
    <div>
      <div className="w-full  max-w-screen-2xl mx-auto flex justify-between">
        <div className="w-full">
          {currentItems.length > 0 ? (
            currentItems.map((item, index) => {
              const totalPrice = item.perDayPricing * item.quantity;

              return (
                <div className="w-full p-5">
                  <div className="w-[100%] h-64 rounded-xl border border-rose-100 shadow-md flex flex-row p-5 gap-6">
                    <div className="w-[70%] h-full flex flex-row gap-5">
                      <div className="w-[30%]">
                        <img
                          className="w-full h-full object-cover rounded-lg"
                          src={item.singleImage}
                          alt={item.title}
                          loading="lazy"
                        />
                      </div>
                      <div className="w-[70%]  flex flex-col gap-2">
                        <div className="w-full  ">
                          <h1 className="text-xl font-semibold mb-2 font-montserrat">
                            {item.title}
                          </h1>
                          <h1>{item.productDescription}</h1>
                        </div>
                        <div className="w-full flex flex-row gap-5 ">
                          <button
                            onClick={() => removeFromCart(item)}
                            type="button"
                            className="flex items-center text-sm font-medium text-red-600 hover:underline"
                          >
                            <svg
                              className="mr-2 h-5 w-5"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M6 18 17.94 6M18 18 6.06 6"
                              />
                            </svg>
                            Remove
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="w-[30%]  h-full flex flex-row gap-5">
                      <div className="w-full flex flex-col justify-center items-center">
                        <h1 className="text-xl text-center font-semibold font-montserrat mb-4">
                          Price:{" "}
                          <span className="">{item.perDayPricing} $ </span>
                        </h1>
                        <form className="w-full">
                          {/* <label className="block font-raleway mb-2 text-md font-medium text-gray-900">
                          Choose quantity:
                        </label> */}

                          <div className="flex justify-center items-center">
                            <button
                              onClick={() => handleQuantityChange(index, -1)}
                              type="button"
                              className="bg-gray-100 hover:bg-gray-200 border border-gray-300 rounded-l-lg p-3 h-11 focus:ring-2 focus:ring-gray-100 focus:outline-none"
                            >
                              <svg
                                className="w-3 h-3 text-gray-900"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 18 2"
                              >
                                <path
                                  stroke="currentColor"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M1 1h16"
                                />
                              </svg>
                            </button>
                            <span className="bg-gray-50 border-x-0 border-gray-300 h-11 text-center text-gray-900 text-md font-bold font-roboto px-4 py-2.5">
                              {item.quantity}
                            </span>
                            <button
                              onClick={() => handleQuantityChange(index, 1)}
                              type="button"
                              className="bg-gray-100 hover:bg-gray-200 border border-gray-300 rounded-r-lg p-3 h-11 focus:ring-2 focus:ring-gray-100 focus:outline-none"
                            >
                              <svg
                                className="w-3 h-3 text-gray-900"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 18 18"
                              >
                                <path
                                  stroke="currentColor"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M9 1v16M1 9h16"
                                />
                              </svg>
                            </button>
                          </div>
                        </form>
                      </div>
                      <div className="w-full  flex justify-center items-center">
                        <h1 className="text-xl font-semibold font-montserrat">
                          Total {totalPrice} $
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <p className="text-gray-700 text-center">Your cart is empty.</p>
          )}
        </div>

        <div className="w-[40%] border border-rose-100  bg-white shadow-md p-5 my-5 rounded-md">
          <div className="space-y-6">
            <p className="text-xl font-semibold text-gray-900">
              Your Contact Info
            </p>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-1 gap-4">
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900">
                    First Name
                  </label>
                  <input
                    type="text"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-rose-500 focus:border-rose-500"
                    placeholder="John"
                    required
                  />
                </div>
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900">
                    Last Name
                  </label>
                  <input
                    type="text"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-rose-500 focus:border-rose-500"
                    placeholder="Doe"
                    required
                  />
                </div>
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900">
                    Email
                  </label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-rose-500 focus:border-rose-500"
                    placeholder="johndoe@gmail.com"
                    required
                  />
                </div>
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900">
                    Phone number
                  </label>
                  <input
                    value={phoneNumber}
                    onChange={handlePhoneChange}
                    type="tel"
                    className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-rose-500 focus:border-rose-500"
                    placeholder="(123) 456-7890"
                    maxLength={13}
                    required
                  />
                </div>
                <p className="text-xl font-semibold text-gray-900">
                  Venue / Delivery Location
                </p>
                {/* Date and Time Selection */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-900">
                      Select booking start date:
                    </label>
  <input
  type="date"
  value={projectSelectDate}
  onChange={(e) => setProjectSelectedDate(e.target.value)}
  className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-rose-500 focus:border-rose-500"
  min={new Date().toISOString().split("T")[0]} // Sets the minimum date to today
/>
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-900">
                      Select Time:
                    </label>
                    <div className="flex gap-2">
                      <select
                        value={projectSelectedHour}
                        onChange={(e) => setProjectSelectedHour(e.target.value)}
                        className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-rose-500 focus:border-rose-500"
                      >
                        {Array.from({ length: 12 }, (_, i) => i + 1).map(
                          (hour) => (
                            <option
                              key={hour}
                              value={hour < 10 ? `0${hour}` : hour}
                            >
                              {hour < 10 ? `0${hour}` : hour}
                            </option>
                          )
                        )}
                      </select>
                      <select
                        value={projectSelectedMinute}
                        onChange={(e) =>
                          setProjectSelectedMinute(e.target.value)
                        }
                        className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-rose-500 focus:border-rose-500"
                      >
                        {Array.from({ length: 12 }, (_, i) => i * 5).map(
                          (minute) => (
                            <option
                              key={minute}
                              value={minute < 10 ? `0${minute}` : minute}
                            >
                              {minute < 10 ? `0${minute}` : minute}
                            </option>
                          )
                        )}
                      </select>
                      <select
                        value={projectSelectedPeriod}
                        onChange={(e) =>
                          setProjectSelectedPeriod(e.target.value)
                        }
                        className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-rose-500 focus:border-rose-500"
                      >
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-900">
                      Select booking end date:
                    </label>
                    <input
                      type="date"
                      value={projectSelectEndDate}
                      onChange={(e) =>
                        setProjectSelectedEndDate(e.target.value)
                      }
                      min={projectSelectDate} 
                      className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-rose-500 focus:border-rose-500"
                    />
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-900">
                      Select Time:
                    </label>
                    <div className="flex gap-2">
                      <select
                        value={projectSelectedHour}
                        onChange={(e) =>
                          setProjectSelectedEndHour(e.target.value)
                        }
                        className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-rose-500 focus:border-rose-500"
                      >
                        {Array.from({ length: 12 }, (_, i) => i + 1).map(
                          (hour) => (
                            <option
                              key={hour}
                              value={hour < 10 ? `0${hour}` : hour}
                            >
                              {hour < 10 ? `0${hour}` : hour}
                            </option>
                          )
                        )}
                      </select>
                      <select
                        value={projectSelectedMinute}
                        onChange={(e) =>
                          setProjectSelectedEndMinute(e.target.value)
                        }
                        className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-rose-500 focus:border-rose-500"
                      >
                        {Array.from({ length: 12 }, (_, i) => i * 5).map(
                          (minute) => (
                            <option
                              key={minute}
                              value={minute < 10 ? `0${minute}` : minute}
                            >
                              {minute < 10 ? `0${minute}` : minute}
                            </option>
                          )
                        )}
                      </select>
                      <select
                        value={projectSelectedPeriod}
                        onChange={(e) =>
                          setProjectSelectedEndPeriod(e.target.value)
                        }
                        className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-rose-500 focus:border-rose-500"
                      >
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                    </div>
                  </div>
                </div>
                {/* Venue Details */}
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900">
                    Venue Name
                  </label>
                  <input
                    type="text"
                    value={VenueName}
                    onChange={(e) => setVenueName(e.target.value)}
                    className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-rose-500 focus:border-rose-500"
                    placeholder="Type..."
                    required
                  />
                </div>
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900">
                    Venue Street Address
                  </label>
                  <input
                    type="text"
                    value={VenueStreetAddressOne}
                    onChange={(e) => setVenueStreetAddressOne(e.target.value)}
                    className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-rose-500 focus:border-rose-500"
                    placeholder="Type..."
                    required
                  />
                </div>
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900">
                    Venue City
                  </label>
                  <input
                    type="text"
                    value={VenueCity}
                    onChange={(e) => setVenueCity(e.target.value)}
                    className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-rose-500 focus:border-rose-500"
                    placeholder="Type..."
                    required
                  />
                </div>
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900">
                    Venue State
                  </label>
                  <input
                    type="text"
                    value={VenueState}
                    onChange={(e) => setVenueState(e.target.value)}
                    className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-rose-500 focus:border-rose-500"
                    placeholder="Type..."
                    required
                  />
                </div>
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900">
                    Venue Postal Code
                  </label>
                  <input
                    type="text"
                    value={VenuePostalCode}
                    onChange={(e) => setVenuePostalCode(e.target.value)}
                    className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-rose-500 focus:border-rose-500"
                    placeholder="Code Number"
                    required
                  />
                </div>
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900">
                    Venue Notes
                  </label>
                  <input
                    type="text"
                    value={VenueNotes}
                    onChange={(e) => setVenueNotes(e.target.value)}
                    className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-rose-500 focus:border-rose-500"
                    placeholder="Type..."
                  />
                </div>
              </div>
              <button
                type="submit"
                className="w-full py-3 bg-rose-700 hover:bg-rose-800 text-white font-medium rounded-lg focus:ring-4 focus:outline-none focus:ring-rose-300"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventCart;
